import { render, staticRenderFns } from "./ArtifactPreviewModal.vue?vue&type=template&id=7503c5d0&"
import script from "./ArtifactPreviewModal.vue?vue&type=script&lang=js&"
export * from "./ArtifactPreviewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports